export const SET_LANDSKAPE = 'SET_LANDSKAPE'

interface SetLandscape {
  type: typeof SET_LANDSKAPE,
  payload: Boolean
}

export interface LandscapeState {
  isLandscape: Boolean
}

export type LandscapeTypes = SetLandscape